import Vue from 'vue';
const state = {
    voucher: {},
    vouchers: [],
}
const actions = {
    showVouchers: (context) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/vouchers`).then(response => {
                context.commit('SHOW_VOUCHERS', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    showVoucher: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/vouchers/${id}`).then(response => {
                context.commit('SHOW_VOUCHER', response.data.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    storeVoucher: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(`/api/vouchers`, payload).then(response => {
                context.commit('STORE_VOUCHER', response.data)
                Vue.$toast.success("Voucher gerado com sucesso");
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    updateVoucher: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.put(`/api/vouchers/${payload.id}`, payload).then(response => {
                Vue.$toast.info("Voucher atualizado com sucesso");
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    destroyVoucher: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/vouchers/${id}`).then(response => {
                Vue.$toast.error("Voucher deletado com sucesso");
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    }
}
const mutations = {

    SHOW_VOUCHER: (state, payload) => {
        state.voucher = payload
    },
    SHOW_VOUCHERS: (state, payload) => {
        state.vouchers = payload
    },
    STORE_VOUCHER: (state, payload) => {
        state.voucher = payload
    }
}
const getters = {
    voucher: state => {
        return state.voucher
    },
    vouchers: state => {
        return state.vouchers
    }
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}